import { render } from "./choose_legacy_cta.html?vue&type=template&id=a3ffa370&external"
import script from "./choose_legacy_cta.js?vue&type=script&lang=js&external"
export * from "./choose_legacy_cta.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__